<template>
  <div>
    <div class="table-header">
      <h3>
        {{ title }}
        <span v-if="dropdown"
            class="table-header-btns">
          <el-dropdown @command="addRowCommand">
            <el-button size="small">
              行追加
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                  v-for="l in dropdownList"
                  :key="l.label"
                  :v-if="l.funcId == null || $isFunctionShown(l.funcId)"
                  :disabled="(l.funcId == null || $isFunctionDisabled(l.funcId)) ||
                    (typeof l.disabledCondition === 'function' ? l.disabledCondition(l.funcId) : false) ||
                    editableCondition(l.command)"
                  :command="l.command">
                {{ l.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </h3>
    </div>
    <table class="order-detail-items">
      <template>
        <colgroup>
          <col v-for="(col, index) in headerList"
              :key="index"
              :style="getColStyle(col)"
              :span="col.colspan">
        </colgroup>
        <tbody is="transition-group"
            class="item-detail-table-body"
            @before-enter="$_tableRowAnimator_beforeEnter"
            @before-leave="$_tableRowAnimator_beforeLeave"
            @enter="$_tableRowAnimator_enter"
            @leave="$_tableRowAnimator_leave">
          <tr key="header">
            <th v-for="(l, i) in headerList"
                :key="i"
                :colspan="l.colspan"
                :class="l.headerClass">
              {{ typeof l.label==="function" ? l.label() : l.label }}
            </th>
          </tr>
          <template v-if="type === 'total'">
            <!-- 小計値引 -->
            <template v-for="priceAdjustment in filteredMerchandisePriceAdjustments">
              <OrderDetailItemsRow
                  :key="getUuid(priceAdjustment) + 'adjustment'"
                  :parent="orderDetail"
                  :origin-data="originData"
                  :mode="mode"
                  :type="type"
                  :row="priceAdjustment"
                  :rows="orderDetail.merchandisePriceAdjustments"
                  :show-tooltip="orderAdjustToolTip"
                  row-type="adjustment"
                  :class="clickableClass('adjustment')"
                  @rowClick="onRowClick"
                  @requestCalculate="requestCalculate" />
            </template>
          </template>
          <template v-else>
            <template v-for="orderItemTypes in orderItemTypesUnit">
              <template v-for="orderItemType in orderItemTypes.orderItemTypes">
                <template v-for="orderItem in filteredItems(orderItemType)">
                  <OrderDetailItemsRow
                      :key="getUuid(orderItem)"
                      :parent="orderDetail"
                      :origin-data="originData"
                      :mode="mode"
                      :type="type"
                      :row="orderItem"
                      :rows="orderDetail[orderItemType]"
                      :row-type="orderItemType"
                      :show-tooltip="itemToolTip"
                      :show-component="componentOpenState(orderItem.id)"
                      :class="clickableClass(orderItemType)"
                      @changeComponentOpenState="changeComponentOpenState"
                      @rowClick="onRowClick"
                      @requestCalculate="requestCalculate" />
                  <template v-if="componentOpenState(orderItem.id)">
                    <!-- 構成品 -->
                    <template v-for="component in itemCompnents(orderItem)">
                      <OrderDetailItemsRow
                          :key="getUuid(component)"
                          :parent="orderDetail"
                          :origin-data="originData"
                          :mode="mode"
                          :type="type"
                          :row="component"
                          :parent-row="orderItem"
                          :rows="itemCompnents(orderItem)"
                          :row-type="'components'"
                          :show-tooltip="itemToolTip"
                          :class="clickableClass(orderItemType)"
                          @rowClick="onRowClick"
                          @requestCalculate="requestCalculate" />
                    </template>
                  </template>
                  <!-- 単品値引 -->
                  <template v-for="priceAdjustment in filteredItemPriceAdjustments(orderItem)">
                    <OrderDetailItemsRow
                        :key="getUuid(priceAdjustment)"
                        :parent="orderDetail"
                        :origin-data="originData"
                        :mode="mode"
                        :type="type"
                        :row="priceAdjustment"
                        :rows="orderItem.priceAdjustments"
                        :show-tooltip="adjustToolTip"
                        :row-type="rowItemAdjustmentType(orderItemType)"
                        :class="clickableClass(rowItemAdjustmentType(orderItemType))"
                        @rowClick="onRowClick"
                        @requestCalculate="requestCalculate" />
                  </template>
                </template>
              </template>
              <!-- 小計 -->
              <tr v-for="l in orderItemTypes.totalItemList"
                  :key="getUuid(l)"
                  :class="l.class">
                <td v-for="p in l.properties"
                    :key="getUuid(p)"
                    :colspan="p.colspan"
                    :class="p.class">
                  <BaseCell
                      :properties="p"
                      :display-item="orderDetail" />
                </td>
              </tr>
            </template>
          </template>
          <!-- 総合計 -->
          <template v-for="l in totalOrderList">
            <tr v-if="l.show == null || (typeof l.show === 'function' ? l.show() : l.show)"
                :key="getUuid(l)"
                :class="l.class">
              <template v-for="p in l.properties">
                <td v-show="p.show == null || p.show"
                    :key="getUuid(p)"
                    :colspan="p.colspan"
                    :class="p.class">
                  <BaseCell
                      :properties="p"
                      :display-item="orderDetail" />
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </template>
    </table>

    <BaseDialog
        title="注文明細"
        :visible.sync="orderItemDialogVisible"
        :before-close="onBeforeCloseOrderItemDialog"
        :show-only-close-button="showOnlyCloseButton(orderItemDetailCopy)"
        @closed="orderItemDialogClose"
        @cancel="orderItemDialogCancel"
        @ok="orderItemDialogOK">
      <template slot="contents">
        <OrderItem
            v-if="orderItemDialogVisible"
            :mode="mode"
            :display-type="orderItemDialogType"
            :target="orderItemDetailCopy"
            :parent="orderItemDetailParent"
            :order-items="orderItems"
            :order-detail="orderDetail"
            :order-detail-origin="originData"
            :read-only="readOnlyOrderItem"
            validate-scope="orderItem" />
      </template>
      <template slot="prependFooter">
        <el-button
            v-if="showQtyDetail"
            class="show-qty-detail-btn"
            @click="showQtyDetailModal">
          数量明細
        </el-button>
        <AttributeButton
            v-if="showQtyDetail"
            class="attribute-button"
            :site-code="siteCode"
            :editable="editableAttribute"
            :attribute-values="attributes"
            :append-to-body="true"
            size=""
            page-name="order_detail"
            :area-name="attributeAreaName" />
      </template>
    </BaseDialog>
    <BaseDialog
        title="数量明細"
        width="35%"
        :visible.sync="qtyDetailDialogVisible"
        :show-footer="false">
      <template slot="contents">
        <QuantityDetail
            type="orderItem"
            :quantity="qtyDetailForDialog" />
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>
.order-detail-items {
  table-layout: fixed;
}
.clickable {
  cursor: pointer;
}
.show-qty-detail-btn {
  float: left;
}
.attribute-button {
  float: left;
  padding-left: 15px;
  }
</style>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import compare from '@/utils/compareUtils'
import math from '@/utils/math'
import uuid from 'uuid/v4'
import * as define from '@/define'
import * as config from '@/config'

import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'
import tableRowAnimator from '@/components/mixins/tableRowAnimator'
import OrderDetailItemsRow from '@/components/pages/order/OrderDetailItemsRow'
import OrderItem from '@/components/pages/order/OrderItem'
import QuantityDetail from '@/components/pages/order/QuantityDetail'

import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseDialog from '@/components/molecules/BaseDialog'

import AttributeButton from '@/components/organisms/AttributeButton'

export default {
  name: 'OrderDetailItems',
  components: {
    BaseCell,
    OrderDetailItemsRow,
    OrderItem,
    QuantityDetail,
    BaseDialog,
    AttributeButton
  },
  mixins: [x, orderUtil, tableRowAnimator],
  inject: ['parentValidator'],
  props: {
    title: {
      type: String,
      default: ''
    },
    orderDetail: {
      type: Object,
      default: () => ({})
    },
    originData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: Number,
      default: define.ORDER_MODE.NORMAL
    },
    type: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'origin', 'total'].indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      // 数量情報行開閉
      qtyDetailIndex: [],
      orderItemDialogVisible: false,
      orderItemDialogForNewRecord: false,
      orderItemDialogPrev: null,
      orderItemDialogType: '',
      orderItemDetail: {},
      orderItemDetailCopy: null,
      orderItemDetailParent: null,
      qtyDetailDialogVisible: false,
      qtyDetailForDialog: {}
    }
  },
  computed: {
    define: () => define,
    ...mapGetters({
      wrappingCharge: 'wrappingCharge',
      shippingCharge: 'shippingCharge',
      codFee: 'codFee',
      getPointAdjustmentConfig: 'getPointAdjustmentConfig'
    }),
    ...mapGetters('OrderDetail', {
      siteCode: 'siteCode',
      taxInfo: 'taxInfo',
      componentOpenState: 'componentOpenState'
    }),
    modalTableList () {
      return ''
    },
    headerList () {
      return this.type === 'total' ? [
        { label: '', width: 100, colspan: 1 },
        {
          label: () => {
            return _.chain(this.orderDetail)
              .get('merchandisePriceAdjustments')
              .filter(val => val.delete !== 1)
              .size()
              .thru(val => val > 0 ? '表示名称' : '')
              .value()
          }, colspan: 14
        },
        { label: '', colspan: 5 },
        { label: '金額', headerClass: 'right', width: 160, colspan: 3 },
        { label: '', width: 45, colspan: 1 }
      ] : [
        { label: '', width: 35, colspan: 1 },
        { label: 'No', width: 25, colspan: 1 },
        { label: '', width: 50, colspan: 2 },
        { label: '', width: 150, colspan: 3 },
        { label: '', width: 100, colspan: 1 },
        { label: 'SKU', width: 180, colspan: 2 },
        { label: '商品名', colspan: 1 },
        { label: '', width: 20, colspan: 1 },
        { label: '', width: 90, colspan: 1 },
        { label: '', colspan: 1 },
        { label: '売価', headerClass: 'right', width: 100, colspan: 3 },
        { label: '数量', headerClass: 'right', width: 60, colspan: 3 },
        { label: '金額', headerClass: 'right', width: 100, colspan: 3 },
        { label: '', width: 45, colspan: 1 }
      ]
    },
    dropdown () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) &&
        ['normal', 'total'].includes(this.type) && this.dropdownList.length > 0
    },
    itemToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'normal'
    },
    componentToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'normal'
    },
    adjustToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'normal'
    },
    orderAdjustToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'total'
    },
    showQtyDetail () {
      return [ 'item', 'component' ].includes(this.orderItemDialogType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QUANTITY_DETAIL)
    },
    filteredMerchandisePriceAdjustments () {
      return _.filter(this.orderDetail.merchandisePriceAdjustments, val => val.delete !== 1)
    },
    totalOrderList () {
      return this.type === 'total'
        ? [
          {
            key: '-orderTotal',
            properties: [
              { path: null, colspan: 15 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '総合計(税込)',
                colspan: 5, class: { bold: true, right: true, 'border-top': true }
              },
              {
                type: 'Number', path: 'orderTotalPrice.gross', colspan: 3,
                class: { bold: true, right: true, 'border-top': true }
              },
              { path: null, class: { 'border-top': true } }
            ]
          },
          {
            key: '-orderTotalTax', show: this.showTotalTax,
            properties: [
              { path: null, colspan: 15 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '(内消費税)',
                colspan: 5, class: { bold: true, right: true }
              },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                path: (row) => {
                  return math.subtract(
                    [
                      _.get(this.orderDetail, 'orderTotalPrice.gross', 0),
                      _.get(this.orderDetail, 'orderTotalPrice.net', 0)
                    ],
                    config.ORDER_CONFIG.price.roundType,
                    config.ORDER_CONFIG.price.decimalDigit)
                }, colspan: 3, class: { bold: true, right: true }
              },
              { path: null }
            ]
          }
        ]
        : [
          {
            key: '-shipmentTotal',
            properties: [
              { path: null, colspan: 13 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '配送合計(税込)',
                colspan: 4, class: { bold: true, right: true, 'border-top': true }
              },
              { path: null, colspan: 3, class: { 'border-top': true } },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                colspan: 3, class: { bold: true, right: true, 'border-top': true },
                path: () => {
                  const gross = _.chain(this.orderDetail)
                    .thru(val => _.concat([], val.items, val.giftItems, val.shippingItems))
                    .filter(val => val != null && val.delete !== 1)
                    .flatMap(val => _.concat([], val, val.priceAdjustments))
                    .filter(val => val != null && val.delete !== 1)
                    .map('price.gross')
                    .value()
                  return math.add(gross)
                }
              },
              { path: null, class: { 'border-top': true } }
            ]
          }
        ]
    },
    orderItemTypesUnit () {
      if (this.type === 'total') {
        return []
      }
      let item = {
        key: 'item',
        orderItemTypes: ['items']
      }
      let itemType = []
      if (this.type === 'received') {
        itemType.push(item)
      } else {
        item.totalItemList = [
          {
            key: '-merchandiseTotal', class: { 'orderdetail-line': true },
            properties: [
              { path: null, colspan: 14 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '小計(税込)',
                colspan: 3, class: { bold: true, right: true }
              },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                path: (row) => {
                  return math.add(
                    _.map(this.orderDetail.items, 'qty.current'),
                    config.ORDER_CONFIG.price.roundType,
                    config.ORDER_CONFIG.price.decimalDigit)
                }, colspan: 3, class: { bold: true, right: true } },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                path: (row) => {
                  return math.add(
                    _.concat([],
                      _.map(this.orderDetail.items, 'price.gross'),
                      _.chain(this.orderDetail.items)
                        .flatMap(val => val.priceAdjustments)
                        .filter(val => val.delete !== 1)
                        .map('price.gross')
                        .filter(val => val != null)
                        .value()
                    ),
                    config.ORDER_CONFIG.price.roundType,
                    config.ORDER_CONFIG.price.decimalDigit)
                }, colspan: 3, class: { bold: true, right: true }
              },
              { path: null }
            ]
          }
        ]

        itemType.push(
          item,
          {
            key: 'gift',
            orderItemTypes: ['giftItems']
          },
          {
            key: 'shipping',
            orderItemTypes: ['shippingItems']
          })
      }
      return itemType
    },
    dropdownList () {
      const dropdownList = this.type === 'total' ? [
        { label: '小計後値引', command: 'merchandisePriceAdjustments',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.TotalDetail.MERCHANDISE_PRICE_ADJUSTMENTS },
        { label: 'ポイント値引', command: 'pointPriceAdjustment',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.TotalDetail.POINT_PRICE_ADJUSTMENTS }
      ] : [
        { label: 'ギフト', command: 'giftItems',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.GIFT },
        { label: '送料', command: 'shippingItems',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.SHIPPING },
        { label: '代引き手数料', command: 'codFeeItems',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.FEE }
      ]
      return dropdownList.filter((element) => { return element.funcId == null || this.$isFunctionShown(element.funcId) })
    },
    cancelAnimation () {
      return this.mode === define.ORDER_MODE.NORMAL
    },
    orderItems () {
      return _.pick(this.orderDetail, ['items'])
    },
    readOnlyOrderItem () {
      return !['normal', 'total'].includes(this.type)
    },
    editableAttribute () {
      return !this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.Attribute.ATTRIBUTE_EDIT) &&
        this.type === 'normal' &&
        [define.ORDER_MODE.EDIT, define.ORDER_MODE.SHORTAGE, define.ORDER_MODE.EXCHANGE].includes(this.mode)
    },
    attributes () {
      return _.get(this.orderItemDetailCopy, 'attributes', [])
    },
    attributeAreaName () {
      return this.orderItemDialogType === 'component' ? 'order_bundle_item' : 'order_item'
    }
  },
  watch: {
    cancelAnimation () {
      this.$_tableRowAnimator_cancelAnimation = this.cancelAnimation
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  mounted () {
    this.$_tableRowAnimator_cancelAnimation = this.cancelAnimation
  },
  methods: {
    ...mapActions('OrderDetail', [
      'calculateTotal',
      'manageComponentOpenState'
    ]),
    filteredItems (orderItemType) {
      return _.filter(this.orderDetail[orderItemType], val => val.delete !== 1)
    },
    itemCompnents (item) {
      return item.bundleItems || []
    },
    filteredItemPriceAdjustments (items) {
      return _.filter(items.priceAdjustments, val => val.delete !== 1)
    },
    showTotalTax () {
      return this.mode === define.ORDER_MODE.NORMAL
    },
    createEmptyOtherItem (config) {
      return config == null ? {} : {
        lineitemText: config.lineitemText,
        basePrice: { net: 0, gross: 0 },
        price: { net: 0, gross: 0 },
        taxRate: math.divide([_.get(this.taxInfo, 'rate', 0), 100]),
        productId: config.productId,
        shipment: { id: null }
      }
    },
    createEmptyGiftItem () {
      const config = this.wrappingCharge(this.siteCode)
      const item = this.createEmptyOtherItem(config)
      item.productName = config.productName
      return item
    },
    createEmptyShippingItem () {
      return this.createEmptyOtherItem(this.shippingCharge(this.siteCode))
    },
    createEmptyCodFeeItem () {
      return this.createEmptyOtherItem(this.codFee(this.siteCode))
    },
    createEmptyPriceAdjustment () {
      return {
        promotionId: '',
        campaignId: '',
        couponId: '',
        reasonCode: '',
        lineitemText: '',
        basePrice: { net: 0, gross: 0 },
        price: { net: 0, gross: 0 }
      }
    },
    createEmptyPointPriceAdjustment () {
      // プロモーションID
      const promotionId = this.getPointAdjustmentConfig(this.siteCode, 'promotion_id')
      // キャンペーンID
      const campaignId = this.getPointAdjustmentConfig(this.siteCode, 'campaign_id')
      // クーポンID
      const couponId = this.getPointAdjustmentConfig(this.siteCode, 'coupon_id')
      // 表示名称
      const lineitemText = this.getPointAdjustmentConfig(this.siteCode, 'lineitem_text')
      return {
        promotionId: promotionId || '', // プロモーションID
        campaignId: campaignId || '', // キャンペーンID
        couponId: couponId || '', // クーポンID
        reasonCode: '', // 理由コード
        lineitemText: lineitemText || '', // 表示名称
        basePrice: { net: 0, gross: 0 }, // 調整単価
        price: { net: 0, gross: 0 }, // 調整金額
        isPoint: 1 // ポイントフラグ
      }
    },
    getUuid (obj) {
      if (!obj.orderDetailItemsKey) {
        obj.orderDetailItemsKey = uuid()
      }
      return obj.orderDetailItemsKey
    },
    /**
     * 商品行、注文値引行追加(ドロップダウン)
     * @param {String} itemType 明細タイプ
     */
    addRowCommand: function (itemType) {
      let addModel = {}
      switch (itemType) {
        case 'shippingItems':
          addModel = this.createEmptyShippingItem()
          break
        case 'codFeeItems':
          addModel = this.createEmptyCodFeeItem()
          // 手数料の場合、itemType を差し替え
          addModel.isCodFee = true
          itemType = 'shippingItems'
          break
        case 'giftItems':
          addModel = this.createEmptyGiftItem()
          break
        case 'merchandisePriceAdjustments':
          addModel = this.createEmptyPriceAdjustment()
          break
        case 'pointPriceAdjustment':
          addModel = this.createEmptyPointPriceAdjustment()
          itemType = 'merchandisePriceAdjustments'
          break
        default:
          return
      }
      this.orderItemDetail = _.cloneDeep(addModel)
      this.orderDetail[itemType].push(this.orderItemDetail)
      this.orderItemDetailCopy = _.cloneDeep(this.orderItemDetail)
      this.orderItemDialogVisible = true
      this.orderItemDialogForNewRecord = true
      switch (itemType) {
        case 'giftItems':
          this.orderItemDialogType = 'giftItem'
          break
        case 'shippingItems':
          this.orderItemDialogType = 'shippingItem'
          break
        case 'merchandisePriceAdjustments':
          this.orderItemDialogType = 'priceAdjustment'
          break
        default:
          break
      }
    },
    onBeforeCloseOrderItemDialog (done) {
      this.revertNewItem()
      done()
    },
    orderItemDialogCancel () {
      this.revertNewItem()
      this.orderItemDialogVisible = false
    },
    revertNewItem () {
      if (!this.orderItemDialogForNewRecord) {
        return
      }
      let list
      switch (this.orderItemDialogType) {
        case 'item':
          list = _.get(this.orderDetail, 'items', [])
          break
        case 'component':
          this.$set(this.orderItemDialogPrev.parent.bundleItems, this.orderItemDialogPrev.index, this.orderItemDialogPrev.item)
          this.orderItemDialogPrev.parent.bundleItems.pop()
          return
        case 'giftItem':
          list = _.get(this.orderDetail, 'giftItems', [])
          break
        case 'shippingItem':
          list = _.get(this.orderDetail, 'shippingItems', [])
          break
        case 'itemPriceAdjustment':
        case 'giftItemPriceAdjustment':
        case 'shippingItemPriceAdjustment':
          list = _.get(this.orderItemDetailParent, 'priceAdjustments', [])
          break
        case 'priceAdjustment':
          list = _.get(this.orderDetail, 'merchandisePriceAdjustments', [])
          break
        default:
          return
      }
      if (this.orderItemDialogPrev) {
        // 元データを復元
        this.$set(list, this.orderItemDialogPrev.index, this.orderItemDialogPrev.item)
      }
      // 追加されている行を削除
      const index = _.findIndex(list,
        val => val.orderDetailItemsKey === this.orderItemDetail.orderDetailItemsKey)
      if (index >= 0) {
        list.splice(index, 1)
      }

      this.calculateTotal()
    },
    async orderItemDialogOK () {
      let canClose = true
      if (['normal', 'total'].includes(this.type)) {
        canClose = await this.$validator.validate('orderItem.*')
      }
      if (canClose) {
        const diff = compare.diff(this.orderItemDetail, this.orderItemDetailCopy)
        _.merge(this.orderItemDetail, this.orderItemDetailCopy)

        if (diff != null) {
          this.calculateTotal()
        }
        this.orderItemDialogVisible = false
      }
    },
    /**
     * 商品明細ダイアログの値を初期化する
     */
    orderItemDialogClose () {
      this.orderItemDetailCopy = null
      this.orderItemDetailParent = null
      this.orderItemDialogType = ''
      this.orderItemDialogForNewRecord = false
      this.orderItemDialogPrev = null
    },
    showQtyDetailModal: function () {
      this.qtyDetailForDialog = this.orderItemDetail.qty
      this.qtyDetailDialogVisible = true
    },
    disabledConditionAddRowDropDown: function () {
      if (this.mode === define.ORDER_MODE.EDIT) {
        return false
      }
      return true
    },
    /**
     * 数量計算
     */
    setCalculateCurrentQty (orderItem) {
      const qty = orderItem.qty
      qty.current = math.add([qty.ordered, -qty.canceled, -qty.inshipCanceled, -qty.transfer, -qty.receiveFixed, qty.exOut, qty.exOutExported, qty.exOutFixed, -qty.exIn, -qty.exInFixed])
      return orderItem
    },
    rowItemAdjustmentType (itemType) {
      switch (itemType) {
        case 'items':
          return 'itemAdjustment'
        case 'giftItems':
          return 'giftItemAdjustment'
        case 'shippingItems':
          return 'shippingItemAdjustment'
      }
    },
    onRowClick (event, row, rowType, isNewline, prev) {
      if (this.canClickRow(rowType)) {
        this.showDetailModal(row, rowType, isNewline, prev)
      }
    },
    changeComponentOpenState (row) {
      this.manageComponentOpenState(row.id)
      return ''
    },
    showDetailModal (rowItem, rowType, isNewline, prev) {
      switch (rowType) {
        case 'items':
          this.orderItemDialogType = 'item'
          break
        case 'components':
          this.orderItemDialogType = 'component'
          break
        case 'giftItems':
          this.orderItemDialogType = 'giftItem'
          break
        case 'shippingItems':
          this.orderItemDialogType = 'shippingItem'
          break
        case 'itemAdjustment':
        case 'giftItemAdjustment':
        case 'shippingItemAdjustment':
          let type
          let parentList
          switch (rowType) {
            case 'itemAdjustment':
              type = 'itemPriceAdjustment'
              parentList = this.orderDetail.items
              break
            case 'giftItemAdjustment':
              type = 'giftItemPriceAdjustment'
              parentList = this.orderDetail.giftItems
              break
            case 'shippingItemAdjustment':
              type = 'shippingItemPriceAdjustment'
              parentList = this.orderDetail.shippingItems
              break
          }
          this.orderItemDialogType = type
          this.orderItemDetailParent = _.find(parentList, val => {
            return _.find(val.priceAdjustments,
              val => val.orderDetailItemsKey === rowItem.orderDetailItemsKey) != null
          })
          break
        case 'adjustment':
          this.orderItemDialogType = 'priceAdjustment'
          break
        default:
          return
      }
      this.orderItemDetail = rowItem
      this.orderItemDetailCopy = _.cloneDeep(rowItem)
      this.orderItemDialogVisible = true
      this.orderItemDialogForNewRecord = isNewline || false
      this.orderItemDialogPrev = prev
    },
    requestCalculate () {
      this.calculateTotal()
    },

    /**
     * ダイアログで閉じるボタンを表示するか判定する
     *  編集不可の場合、閉じるボタンのみの表示となる
     * @param {*} orderItem 注文明細行
     * @return {Booleam} 閉じるボタンの表示
     */
    showOnlyCloseButton (row) {

      // データがない場合、編集不可
      if (row == null) return true

      // コンポーネントタイプが 通常、合計 以外の場合、編集不可
      if (!['normal', 'total'].includes(this.type)) return true

      // モードが 通常、配送先登録、手動決済、支払方法変更の場合、編集不可
      if ([define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT,
        define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode)) return true

      // 以外は OK 編集可のため、閉じるボタンは表示しない
      return false

    },

    getColStyle (col) {
      const style = {}
      if (col.width != null) {
        style.width = `${col.width / _.get(col, 'colspan', 1)}px`
      }
      return style
    },
    clickableClass (rowType) {
      if (this.canClickRow(rowType)) {
        return 'clickable'
      }
      return ''
    },
    canClickRow (rowType) {
      if ((rowType === 'adjustment' && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.TotalDetail.ADJUSTMENTS_DETAIL)) ||
        (['items', 'components'].includes(rowType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.PRODUCT_DETAIL)) ||
        (['shippingItems', 'giftItems', 'codFeeItems'].includes(rowType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.FEE_DETAIL)) ||
        (['itemAdjustment', 'shippingItemAdjustment', 'giftItemAdjustment'].includes(rowType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.DISCOUNT_DETAIL))) {
        return true
      }
      return false
    },
    /** 編集可否条件 */
    editableCondition: function (command) {
      if (command === 'pointPriceAdjustment') {
        return _.chain(this.orderDetail)
          .get('merchandisePriceAdjustments')
          .filter(val => val.isPoint === 1 && val.delete !== 1)
          .size() > 0
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/OrderDetailItems.vue